import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { TransactionTypeCodeEnum, } from "@domains/features/Markets/AIF-PMS/entities/GlobalEntity";
import { ONE_LAKH_RUPEE } from "../../constants";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import actions from "@mainDi/features/AIF-PMS/actions";
import * as URLConfig from "@frameworks/salesjourney/config/domain";
var PurchaseFooter = function (_a) {
    var onClickCancel = _a.onClickCancel, onClickContinue = _a.onClickContinue, leadId = _a.leadId, setLeadId = _a.setLeadId, setRmSelection = _a.setRmSelection, rmSelection = _a.rmSelection, leadNotExists = _a.leadNotExists, setLeadNotExits = _a.setLeadNotExits, setIsCxoButtonEnabled = _a.setIsCxoButtonEnabled, isCxoButtonEnabled = _a.isCxoButtonEnabled;
    var cActions = actions();
    var _b = useSelector(function (state) { return state.markets.AifPms; }), watchListData = _b.watchListData, orderData = _b.orderData, clientDetails = _b.clientDetails, draftOrderDetails = _b.draftOrderDetails, subCategoryId = _b.subCategoryId;
    var searchParams = new URLSearchParams(location.search);
    var _c = useSelector(function (state) { return state.markets.leadservice; }), leadData = _c.leadData, selectLoginSearchData = _c.selectLoginSearchData;
    var selectLeadId = useSelector(function (state) { return state.markets.global; }).selectLeadId;
    var _d = useSelector(function (state) { return state.markets.payment; }), paymentSuccess = _d.paymentSuccess, paymentMode = _d.paymentMode, purchase = _d.purchase, topup = _d.topup, purchaseFee = _d.purchaseFee, arnTransfer = _d.arnTransfer, uploadDeclaration = _d.uploadDeclaration, redeem = _d.redeem;
    var saveDraftOrders = useSelector(function (state) { return state.markets.draft; }).saveDraftOrders;
    var profileData = useSelector(function (state) {
        return state.Profile.ProfileDetails.reducersData.data.profileDetails;
    });
    var validateForm = useSelector(function (state) { return state.markets.purchase; }).validateForm;
    var activeTypeList = useSelector(function (state) { return state.markets.global; }).activeTypeList;
    var paymentProcess = useSelector(function (state) { return state.markets.payment; });
    var isPurchaseOrTopUp = useMemo(function () {
        return [
            TransactionTypeCodeEnum.Purchase,
            TransactionTypeCodeEnum.TopUp,
        ].includes(activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code);
    }, [activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code]);
    var isButtonDisabled = function () {
        var transactionFieldRequirements = {
            Purchase: ["purchase", "paymentMode", "purchaseFee", "uploadDeclaration"],
            TopUp: ["topup", "paymentMode", "purchaseFee", "uploadDeclaration"],
            Redeem: ["redeem", "purchaseFee", "uploadDeclaration"],
            "Transfer In": ["arnTransfer", "purchaseFee", "uploadDeclaration"],
        };
        var validatePurchase = function (section) {
            var amount = purchase.amount, formNo = purchase.formNo;
            var removedAmount = amount === null || amount === void 0 ? void 0 : amount.split(",").join("");
            if ((removedAmount &&
                Number(removedAmount) < (watchListData === null || watchListData === void 0 ? void 0 : watchListData.min_investment)) ||
                !(formNo === null || formNo === void 0 ? void 0 : formNo.trim())) {
                return true;
            }
            if (paymentMode.bankName.value == "") {
                return true;
            }
            return false;
        };
        var validatePaymentMode = function (section) {
            var type = section.type, rtgsNo = section.rtgsNo, chequeDate = section.chequeDate, chequeNo = section.chequeNo;
            if (type === "RTGS") {
                if (!rtgsNo || rtgsNo.length <= 2) {
                    return true;
                }
            }
            if (type === "Cheque") {
                if (!chequeDate ||
                    !chequeNo ||
                    (chequeNo === null || chequeNo === void 0 ? void 0 : chequeNo.trim()) == "" ||
                    !/^[a-zA-Z0-9 ]*$/.test(chequeNo)) {
                    return true;
                }
            }
            return false;
        };
        var validateTopup = function (section) {
            var amount = topup.amount, folio = topup.folio;
            var removedAmount = amount === null || amount === void 0 ? void 0 : amount.split(",").join("");
            if (removedAmount == "" || Number(removedAmount) < ONE_LAKH_RUPEE) {
                return true;
            }
            if (folio == "") {
                return true;
            }
            return false;
        };
        var validatePurchaseFee = function (section) {
            var _a;
            var passout = purchaseFee.passout, sbName = purchaseFee.sbName;
            var passoutValue = parseFloat(passout);
            var hasDisplayName = (_a = sbName === null || sbName === void 0 ? void 0 : sbName.display_name) === null || _a === void 0 ? void 0 : _a.trim();
            if ((hasDisplayName && isNaN(passoutValue)) ||
                (!hasDisplayName && passoutValue > 0)) {
                return true;
            }
            return false;
        };
        var validateArnTransfer = function (section) {
            var amount = arnTransfer.amount, transferIn = arnTransfer.transferIn;
            var removedAmount = amount === null || amount === void 0 ? void 0 : amount.split(",").join("");
            if (removedAmount == "") {
                return true;
            }
            if (transferIn == "") {
                return true;
            }
            return false;
        };
        var validateRedeem = function (section) {
            var folio = redeem.folio, redeemAmount = redeem.redeemAmount, termAccepted = redeem.termAccepted;
            if (folio == "") {
                return true;
            }
            if (redeemAmount == "") {
                return true;
            }
            if (!termAccepted) {
                return true;
            }
            return false;
        };
        var validateUploadDeclaration = function (section) {
            if (Array.isArray(uploadDeclaration) && uploadDeclaration.length === 0) {
                return true;
            }
            return false;
        };
        var validateSection = function (section, sectionKey) {
            switch (sectionKey) {
                case "purchase":
                    return validatePurchase(section);
                case "paymentMode":
                    return validatePaymentMode(section);
                case "topup":
                    return validateTopup(section);
                case "purchaseFee":
                    return validatePurchaseFee(section);
                case "redeem":
                    return validateRedeem(section);
                case "arnTransfer":
                    return validateArnTransfer(section);
                case "uploadDeclaration":
                    return validateUploadDeclaration(section);
                default:
                    return false;
            }
        };
        var transactionType = activeTypeList.trx_type;
        var requiredFieldsForTransaction = transactionFieldRequirements[transactionType];
        if (!requiredFieldsForTransaction) {
            console.error("No required fields defined for transaction type: ".concat(transactionType));
            return false;
        }
        return requiredFieldsForTransaction.some(function (sectionKey) {
            var section = paymentProcess[sectionKey];
            if (!section) {
                console.log("".concat(sectionKey, " section is missing"));
                return true;
            }
            return validateSection(section, sectionKey);
        });
    };
    var onClickContinueIfDraftFailed = function () {
        var _a, _b, _c, _d, _e;
        if (validateForm && validateForm.data && validateForm.data.trxid > 0) {
            aifPmsDi.aifPms.updateTransactionId((_a = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _a === void 0 ? void 0 : _a.trxid);
        }
        else {
            aifPmsDi.aifPms.updateTransactionId((_b = saveDraftOrders === null || saveDraftOrders === void 0 ? void 0 : saveDraftOrders.data) === null || _b === void 0 ? void 0 : _b.trxId);
        }
        cActions.purchase.updateValidateForm({
            requestid: "",
            success: false,
            message: "",
            statuscode: "",
            errors: "",
            data: {
                is_formNoExist: false,
                message: "",
                is_edit: false,
                trxid: (_c = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _c === void 0 ? void 0 : _c.trxid,
                trxtype: "",
            },
        });
        aifPmsDi.draft.updateDraftOrders(null);
        if (validateForm && validateForm.data && validateForm.data.trxid > 0) {
            aifPmsDi.draft.draftOrderDetails({
                trx_id: Number((_d = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _d === void 0 ? void 0 : _d.trxid),
            });
        }
        else {
            aifPmsDi.draft.draftOrderDetails({
                trx_id: Number((_e = saveDraftOrders === null || saveDraftOrders === void 0 ? void 0 : saveDraftOrders.data) === null || _e === void 0 ? void 0 : _e.trxId),
            });
        }
    };
    var leadNotFound = useMemo(function () {
        return (leadData === null || leadData === void 0 ? void 0 : leadData.data) === null;
    }, [leadData === null || leadData === void 0 ? void 0 : leadData.data]);
    var onClickGoBack = function () {
        onClickCancel();
        var cActions = actions();
        cActions.leadservice.searchLead(null);
        cActions.leadservice.selectLoginSearchData(null);
    };
    var onClickCreateLink = function () {
        var path = "".concat(URLConfig.config.applicationRoot, "dashboard/leadpage?ucc=").concat(clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.ucccode, "&schemeId=").concat(watchListData === null || watchListData === void 0 ? void 0 : watchListData.schemeId, "&&schemename=").concat(watchListData === null || watchListData === void 0 ? void 0 : watchListData.display_name);
        window.open(path, "_blank", "noopener,noreferrer");
    };
    var onClickNoGoback = function () {
        onClickCancel();
        setRmSelection(false);
        var cActions = actions();
        cActions.leadservice.searchLead(null);
        cActions.leadservice.selectLoginSearchData(null);
    };
    var onClickContinueButton = function () {
        if (leadId && isPurchaseOrTopUp) {
            if (profileData === null || profileData === void 0 ? void 0 : profileData.isCxo) {
                if ((clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.client_owner) !== (selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_code)) {
                    setRmSelection(true);
                }
                else {
                    setRmSelection(false);
                    setLeadId(false);
                }
            }
            else {
                setLeadId(false);
                setLeadNotExits(false);
            }
        }
        else {
            onClickContinue();
        }
    };
    var onClickCxoButton = function () {
        setIsCxoButtonEnabled(true);
        onClickContinueButton();
    };
    var isContinueButtonDisabled = (leadId || leadNotExists) &&
        !draftOrderDetails &&
        (clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.ispansearch) !== "true" &&
        isPurchaseOrTopUp
        ? !selectLeadId || !clientDetails
            ? true
            : false
        : isButtonDisabled();
    var isCXODisabled = selectLoginSearchData == null;
    var getButtonGroup = function () {
        var _a, _b, _c;
        switch (true) {
            // Case for successful payment and a purchase or top-up
            case paymentSuccess &&
                isPurchaseOrTopUp &&
                !(orderData === null || orderData === void 0 ? void 0 : orderData.issuer_redirection_url):
                return (React.createElement("div", { className: "d-flex justify-content-center flex-wrap gap-2 align-items-center" },
                    React.createElement(EdButton, { onClick: function () {
                            onClickCancel();
                            setLeadId(true);
                            var cActions = actions();
                            cActions.draft.draftOrderDetails(null);
                            if (typeof searchParams !== "undefined") {
                                var url = window.location.pathname;
                                window.history.replaceState(null, "", url);
                            }
                        }, btnTyp: "link", value: "Close", className: "rounded-pill DMSans_16_500 px-5 py-2" }),
                    React.createElement(EdButton, { onClick: function () {
                            var path = "".concat(URLConfig.config.applicationRoot, "dashboard/orderbook?orderId=").concat(orderData === null || orderData === void 0 ? void 0 : orderData.trx_id, "&categoryCode=").concat(subCategoryId, "&productCode=56&isAifPms=true&productType=1");
                            window.open(path, "_blank", "noopener,noreferrer");
                            onClickCancel();
                        }, btnTyp: "tomato", value: "View Orderbook", className: "partner-proceed rounded-pill DMSans_16_500 px-4 py-2" })));
            // Case for when payment isn't successful, lead not found, and the order is a purchase or top-up
            // case !paymentSuccess &&
            //   leadNotFound &&
            //   !draftOrderDetails &&
            //   clientDetails &&
            //   clientDetails?.ispansearch !== "true" &&
            //   !draftOrderDetails?.data?.lead_id &&
            //   isPurchaseOrTopUp:
            //   return (
            //     <div className="d-flex justify-content-center flex-wrap">
            //       <EdButton
            //         onClick={onClickGoBack}
            //         btnTyp={"link"}
            //         value="Go Back"
            //         className="DMSans_16_500"
            //       />
            //       <EdButton
            //         onClick={onClickCreateLink}
            //         btnTyp={"tomato"}
            //         value="Create Lead"
            //         className="partner-proceed rounded-pill DMSans_16_500 width-180 px-0"
            //         disabled={false}
            //       />
            //     </div>
            //   );
            // Case for when payment isn't successful, with RM selection and client owner mismatch
            case !paymentSuccess &&
                clientDetails &&
                !draftOrderDetails &&
                rmSelection &&
                (clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.client_owner) !== (selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_code):
                return (React.createElement("div", { className: "d-flex justify-content-center flex-wrap" },
                    React.createElement(EdButton, { onClick: onClickNoGoback, btnTyp: "link", value: "No, Go Back", className: "DMSans_16_500" }),
                    React.createElement(EdButton, { onClick: function () {
                            setRmSelection(false);
                            setLeadId(false);
                        }, btnTyp: "tomato", value: "Yes, Proceed", className: "partner-proceed rounded-pill DMSans_16_500 width-180 px-0" })));
            case !paymentSuccess &&
                (profileData === null || profileData === void 0 ? void 0 : profileData.isCxo) &&
                !!(selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_name) &&
                !isCxoButtonEnabled:
                return (React.createElement("div", { className: "d-flex justify-content-center flex-wrap" },
                    React.createElement(EdButton, { onClick: onClickCancel, btnTyp: "link", value: "Cancel", className: "DMSans_16_500" }),
                    React.createElement(EdButton, { onClick: onClickCxoButton, btnTyp: isCXODisabled ? "midnight-blue" : "tomato-red", value: "Continue", className: "partner-proceed rounded-pill DMSans_16_500 width-180 px-0", disabled: isCXODisabled })));
            // Case for default buttons (Cancel and Continue) with different styles and logic
            case !paymentSuccess:
                return (React.createElement("div", { className: "d-flex justify-content-center flex-wrap" },
                    React.createElement(EdButton, { onClick: onClickCancel, btnTyp: "link", value: "".concat(leadId &&
                            clientDetails &&
                            !draftOrderDetails &&
                            (clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.ispansearch) !== "true" &&
                            !((_a = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _a === void 0 ? void 0 : _a.lead_id) &&
                            [
                                TransactionTypeCodeEnum.Purchase,
                                TransactionTypeCodeEnum.TopUp,
                            ].includes(activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code)
                            ? "Go Back"
                            : "Cancel"), className: "DMSans_16_500" }),
                    (((_b = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _b === void 0 ? void 0 : _b.is_edit) &&
                        ((_c = validateForm === null || validateForm === void 0 ? void 0 : validateForm.data) === null || _c === void 0 ? void 0 : _c.is_formNoExist)) ||
                        (saveDraftOrders &&
                            saveDraftOrders.data &&
                            saveDraftOrders.data.status === "FAILUREDRAFT") ? (React.createElement(EdButton, { onClick: onClickContinueIfDraftFailed, btnTyp: "tomato-red", value: "Continue", className: "partner-proceed rounded-pill DMSans_16_500 width-180 px-0", disabled: false })) : (React.createElement(EdButton, { onClick: onClickContinueButton, btnTyp: "".concat((leadId || leadNotExists) &&
                            !draftOrderDetails &&
                            (clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.ispansearch) !== "true" &&
                            [
                                TransactionTypeCodeEnum.Purchase,
                                TransactionTypeCodeEnum.TopUp,
                            ].includes(activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code)
                            ? !selectLeadId || !clientDetails
                                ? "midnight-blue"
                                : "tomato-red"
                            : isButtonDisabled()
                                ? "midnight-blue"
                                : "tomato-red"), value: "Continue", className: "partner-proceed rounded-pill DMSans_16_500 width-180 px-0", disabled: isContinueButtonDisabled }))));
            // Case for successful payment with specific transaction types (Redeem or TransferIn)
            case paymentSuccess &&
                (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code) !== TransactionTypeCodeEnum.TransferIn:
                return (React.createElement("div", { className: "d-flex justify-content-center flex-wrap gap-2" },
                    React.createElement(EdButton, { onClick: onClickCancel, btnTyp: "link", value: "Close", className: "DMSans_16_500 px-0" }),
                    React.createElement(EdButton, { onClick: function () {
                            var path = "".concat(URLConfig.config.applicationRoot, "dashboard/orderbook?orderId=").concat(orderData === null || orderData === void 0 ? void 0 : orderData.trx_id, "&categoryCode=").concat(subCategoryId, "&productCode=56&isAifPms=true&productType=1");
                            window.open(path, "_blank", "noopener,noreferrer");
                            onClickCancel();
                        }, btnTyp: "tomato", value: "View Orderbook", className: "partner-proceed rounded-pill DMSans_16_500 px-4 py-2" })));
            default:
                return null; // Default fallback, just in case
        }
    };
    return React.createElement(React.Fragment, null, getButtonGroup());
};
export default PurchaseFooter;
